$(function() {
    const checkCheckbox =  () => {
        const notCheckedCount = $('.order-confirmetion--checkbox input[type="checkbox"]:not(:checked)').length;
        // console.log('notCheckedCount', notCheckedCount);

        const button = $('.button-product--form .product-form__submit');

        if (notCheckedCount == 0) {
            button.attr('disabled', null);
        } else {
            // disable
            if(button[0].innerHTML.search('売り切れ') == -1) {
                button.attr('disabled', 'disabled');
            }
        }
    };


    $('.order-confirmetion--checkbox input').on('change', checkCheckbox);
    checkCheckbox();

    window.customOrderCheckCheckbox = checkCheckbox;

});